import { BaseApiService } from './baseApiService';

export interface MeetingTokenResponse {
  appId: string;
  channelName: string;
  uid: string | number;
  token: string;
  tokenExpiresAt: string;  // ISO timestamp
  role: string;
}

interface GenerateMeetingTokenRequest {
  meeting_id: string;
  patient: number;
}

class MeetingService extends BaseApiService {
  async generateToken(payload: GenerateMeetingTokenRequest): Promise<MeetingTokenResponse> {
    const response = await this.fetchWithAuth('/meetings/generate-token/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (response?.data) {
      return response.data;
    }

    return response as MeetingTokenResponse;
  }
}

export const meetingService = new MeetingService();
